import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { addMonths, format, subMonths } from "date-fns";
import { ru } from "date-fns/locale";
import IconButton from "@mui/material/IconButton";
import Fade from "@mui/material/Fade";
import { Box } from "../../Box/index.js";
import { Typography } from "../../Typography/index.js";
import { Icon } from "../../Icon/index.js";
import CalendarHeader_styles from "./CalendarHeader.styles.js";
const CalendarHeader = (t0)=>{
    const $ = c(31);
    const { currentMonth, onMonthChange } = t0;
    const { classes } = CalendarHeader_styles();
    const [isFading, setIsFading] = useState(false);
    let t1;
    if ($[0] !== currentMonth || $[1] !== onMonthChange) {
        t1 = ()=>{
            setIsFading(true);
            onMonthChange(addMonths(currentMonth, 1), "left");
            setTimeout(()=>{
                setIsFading(false);
            }, 200);
        };
        $[0] = currentMonth;
        $[1] = onMonthChange;
        $[2] = t1;
    } else t1 = $[2];
    const selectNextMonth = t1;
    let t2;
    if ($[3] !== currentMonth || $[4] !== onMonthChange) {
        t2 = ()=>{
            setIsFading(true);
            onMonthChange(subMonths(currentMonth, 1), "right");
            setTimeout(()=>{
                setIsFading(false);
            }, 200);
        };
        $[3] = currentMonth;
        $[4] = onMonthChange;
        $[5] = t2;
    } else t2 = $[5];
    const selectPreviousMonth = t2;
    const t3 = classes.switchHeader;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ jsx(Box, {
            width: 24,
            height: 24,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "chevron_left",
                size: "16"
            })
        });
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== classes.iconButton || $[8] !== selectPreviousMonth) {
        t5 = /*#__PURE__*/ jsx(IconButton, {
            className: classes.iconButton,
            onClick: selectPreviousMonth,
            title: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u043C\u0435\u0441\u044F\u0446",
            children: t4
        });
        $[7] = classes.iconButton;
        $[8] = selectPreviousMonth;
        $[9] = t5;
    } else t5 = $[9];
    const t6 = classes.fadeContainer;
    const t7 = !isFading;
    let t8;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            enter: "cubic-bezier(0.1, 1, 0.6, 1)"
        };
        $[10] = t8;
    } else t8 = $[10];
    const t9 = classes.lable;
    let t10;
    if ($[11] !== currentMonth) {
        t10 = format(currentMonth, "LLLL yyyy", {
            locale: ru
        });
        $[11] = currentMonth;
        $[12] = t10;
    } else t10 = $[12];
    let t11;
    if ($[13] !== classes.lable || $[14] !== t10) {
        t11 = /*#__PURE__*/ jsx(Box, {
            width: "fit-content",
            children: /*#__PURE__*/ jsx(Typography, {
                variant: "body2",
                className: t9,
                children: t10
            })
        });
        $[13] = classes.lable;
        $[14] = t10;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== t11 || $[17] !== t7) {
        t12 = /*#__PURE__*/ jsx(Fade, {
            in: t7,
            timeout: 200,
            easing: t8,
            children: t11
        });
        $[16] = t11;
        $[17] = t7;
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== classes.fadeContainer || $[20] !== t12) {
        t13 = /*#__PURE__*/ jsx("div", {
            className: t6,
            children: t12
        });
        $[19] = classes.fadeContainer;
        $[20] = t12;
        $[21] = t13;
    } else t13 = $[21];
    let t14;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ jsx(Box, {
            width: 24,
            height: 24,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "chevron_right",
                size: "16"
            })
        });
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== classes.iconButton || $[24] !== selectNextMonth) {
        t15 = /*#__PURE__*/ jsx(IconButton, {
            className: classes.iconButton,
            onClick: selectNextMonth,
            title: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u043C\u0435\u0441\u044F\u0446",
            children: t14
        });
        $[23] = classes.iconButton;
        $[24] = selectNextMonth;
        $[25] = t15;
    } else t15 = $[25];
    let t16;
    if ($[26] !== classes.switchHeader || $[27] !== t13 || $[28] !== t15 || $[29] !== t5) {
        t16 = /*#__PURE__*/ jsxs("div", {
            className: t3,
            children: [
                t5,
                t13,
                t15
            ]
        });
        $[26] = classes.switchHeader;
        $[27] = t13;
        $[28] = t15;
        $[29] = t5;
        $[30] = t16;
    } else t16 = $[30];
    return t16;
};
export { CalendarHeader };
